import './ChooseOrCreateSubFlowModal.scss';
class CreateSubFlowModalController {
    static $inject = ['close', 'confirm', 'size', 'modalClass', 'APPLICATION_DEFAULT_IMAGE', 'whatIsSubflow'];
    constructor(close, confirm, size, modalClass, APPLICATION_DEFAULT_IMAGE, whatIsSubflow) {
        this.close = close;
        this.confirm = confirm;
        this.size = size;
        this.modalClass = modalClass;
        this.APPLICATION_DEFAULT_IMAGE = APPLICATION_DEFAULT_IMAGE;
        this.whatIsSubflow = whatIsSubflow;
        this._close = this.close;
    }
    async selectChooseSubflow() {
        this._confirm(true);
    }
    async selectCreateSubflow() {
        this._confirm(false);
    }
    async _confirm(choose) {
        this.confirm(choose);
        this._close(true);
    }
    async cancel() {
        this._close(false);
    }
}
CreateSubFlowModalController.$inject = ['close', 'confirm', 'size', 'modalClass', 'APPLICATION_DEFAULT_IMAGE', 'whatIsSubflow'];
export default CreateSubFlowModalController;
